/* eslint-disable class-methods-use-this */
class MockMap {
  addListener() {}
  setCenter() {}
  setZoom() {}
  fitBounds() {}

  constructor(element: HTMLElement) {
    const newEl = document.createElement('div');
    newEl.setAttribute('role', 'application');
    element.appendChild(newEl);
  }
}

class MockMarker {
  config?: unknown;
  constructor(config?: unknown) {
    this.config = config;
  }
}

class MockBounds {
  extend() {}
}

class MockInfoWindow {
  extend() {}
}

export class MockLatLng {
  longitude: number;
  latitude: number;
  constructor(lat: number, lng: number) {
    this.latitude = lat;
    this.longitude = lng;
  }

  lat() {
    return this.latitude;
  }

  lng() {
    return this.longitude;
  }
}

class MockDirectionsService {
  route() {
    return Promise.resolve();
  }
}

class MockDirectionsRenderer {
  setDirections() {}
  setMap() {}
}

class MockAutocompleteService {
  getPlacePredictions() {}
}

class MockGeocoder {
  geocode() {}
}

class MockPlacesService {
  getDetails() {}
}

export const setUpMapsAPI = () => {
  global.google = {
    maps: {
      Map: MockMap,
      Marker: MockMarker,
      LatLngBounds: MockBounds,
      InfoWindow: MockInfoWindow,
      DirectionsService: MockDirectionsService,
      DirectionsRenderer: MockDirectionsRenderer,
      LatLng: MockLatLng,
      Geocoder: MockGeocoder,
      GeocoderLocationType: { GEOMETRIC_CENTER: 'GEOMETRIC_CENTER' },
      GeocoderStatus: { OK: 'OK', ERROR: 'ERROR' },

      TravelMode: {
        DRIVING: 'driving'
      },
      event: {
        removeListener: () => {},
        clearInstanceListeners: () => {}
      },
      places: {
        Autocomplete: class Autocomplete {},
        AutocompleteService: MockAutocompleteService,
        AutocompleteSessionToken: class AutocompleteSessionToken {},
        PlacesService: MockPlacesService,
        PlacesServiceStatus: {
          OK: 'OK'
        }
      },
      marker: {
        PinElement: class PinElement {},
        AdvancedMarkerElement: class AdvancedMarkerElement {}
      }
    }
  } as unknown as typeof google;

  (global.navigator.permissions as Permissions) = {
    query: () => Promise.resolve({ state: 'granted' } as PermissionStatus)
  };
};

export const tearDownMapsAPI = () => {
  global.google = undefined as unknown as typeof google;
};
